import React from "react";

const CircularLoader = ({
  size = 40,
  src = "https://qerp-public.s3.sa-east-1.amazonaws.com/static/gifs/loading-new-blue-small.gif",
  alt = "Loading",
}) => {
  return (
    <img
      src={src}
      alt={alt}
      style={{
        width: size,
        height: size,
        display: "block",
      }}
    />
  );
};

export default CircularLoader;
